if (!customElements.get('ahti-hero-carousel')) {
  customElements.define('ahti-hero-carousel', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.slides = [...this.querySelectorAll('.ahti-carousel__slide')];
      this.index = 0;
      this.paused = this.dataset.autoplay !== 'true';
      this.hovered = false;
      this.focused = false;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.controls = this.querySelector('.ahti-carousel__controls');
      if (this.slides.length < 2 || !this.controls) return;
      this.controls.hidden = false;
      this.pauseButton = this.querySelector('[data-pause]');
      this.querySelector('[data-next]').addEventListener('click', () => this.show(this.index + 1), {signal});
      this.querySelector('[data-previous]').addEventListener('click', () => this.show(this.index - 1), {signal});
      this.pauseButton.addEventListener('click', () => { this.paused = !this.paused; this.sync(); }, {signal});
      this.addEventListener('mouseenter', () => {this.hovered = true; this.sync();}, {signal});
      this.addEventListener('mouseleave', () => {this.hovered = false; this.sync();}, {signal});
      this.addEventListener('focusin', () => {this.focused = true; this.sync();}, {signal});
      this.addEventListener('focusout', e => {if (!this.contains(e.relatedTarget)) {this.focused = false; this.sync();}}, {signal});
      document.addEventListener('visibilitychange', () => this.sync(), {signal});
      this.motion.addEventListener('change', () => this.sync(), {signal});
      this.sync();
    }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.querySelector('[data-counter]').textContent = `${this.index + 1} / ${this.slides.length}`;
      this.sync();
    }
    sync() {
      clearTimeout(this.timer);
      const stopped = this.paused || this.motion.matches;
      this.pauseButton.textContent = stopped ? 'Play' : 'Pause';
      this.pauseButton.setAttribute('aria-label', stopped ? 'Play image rotation' : 'Pause image rotation');
      if (!stopped && !this.hovered && !this.focused && !document.hidden) {
        this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 7000);
      }
    }
    disconnectedCallback() {clearTimeout(this.timer); this.controller?.abort();}
  });
}
